import axios from "axios";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../../button/back";

const TampilanKokulikuler = () => {
  const { id } = useParams();
  /* ================= STATE ================= */
  const [filter, setFilter] = useState({
    kelas: "",
    rombel: "",
    tahun: "",
    semester: "",
  });

  const [siswas, setSiswas] = useState([]);
  const [kokulikuler, setKokulikuler] = useState(null);

  /**
   * profileLulusan:
   * [
   *  {
   *    studentId,
   *    dimensiTercapai: [{ DimensiProfile, SubDimensi }],
   *    Deskripsi
   *  }
   * ]
   */
  const [profileLulusan, setProfileLulusan] = useState([]);

  /* ================= HANDLER ================= */
  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };

  /* ================= AMBIL DATA ================= */
  const handleCari = async () => {
    if (!filter.kelas || !filter.rombel || !filter.tahun || !filter.semester) {
      return alert("Lengkapi semua filter");
    }

    try {
      const token = localStorage.getItem("token");

      /* ===== SISWA ===== */
      const resSiswa = await axios.get(
        `${process.env.REACT_APP_API_URL}api/auth/users`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const filteredSiswas = resSiswa.data.filter(
        (u) =>
          u.role === "siswa" &&
          String(u.kelas) === filter.kelas &&
          u.rombel === filter.rombel,
      );
      setSiswas(filteredSiswas);

      /* ===== KOKULIKULER ===== */
      const resKok = await axios.get(
        `${process.env.REACT_APP_API_URL}api/kokulikuler/${filter.kelas}/${filter.rombel}/${filter.tahun}/${filter.semester}`,
      );

      const dataKok = resKok.data;
      setKokulikuler(dataKok);

      /* ===== SINKRON PROFILE (AMAN) ===== */
      const profiles = filteredSiswas.map((s) => {
        const p = dataKok.profileLulusan?.find(
          (x) => String(x.studentId?._id || x.studentId) === String(s._id),
        );

        return {
          studentId: s._id,
          dimensiTercapai: Array.isArray(p?.DimensiLulusan)
            ? p.DimensiLulusan.map((d) => ({
                DimensiProfile: d.DimensiProfile,
                SubDimensi: d.SubDimensi,
              }))
            : [],
          Deskripsi: p?.Deskripsi || "",
        };
      });

      setProfileLulusan(profiles);
    } catch (error) {
      console.error(error);
      alert("Data tidak ditemukan");
    }
  };

  /* ================= TOGGLE CHECKBOX ================= */
  const toggleDimensi = (studentId, dimensi) => {
    setProfileLulusan((prev) =>
      prev.map((p) => {
        if (p.studentId !== studentId) return p;

        const exists = p.dimensiTercapai.some(
          (d) =>
            d.DimensiProfile === dimensi.DimensiProfile &&
            d.SubDimensi === dimensi.SubDimensi,
        );

        return {
          ...p,
          dimensiTercapai: exists
            ? p.dimensiTercapai.filter(
                (d) =>
                  !(
                    d.DimensiProfile === dimensi.DimensiProfile &&
                    d.SubDimensi === dimensi.SubDimensi
                  ),
              )
            : [...p.dimensiTercapai, dimensi],
        };
      }),
    );
  };

  /* ================= UPDATE ================= */
  const handleUpdate = async () => {
    if (!kokulikuler) return alert("Cari data terlebih dahulu");

    try {
      const token = localStorage.getItem("token");

      const payload = profileLulusan.map((p) => ({
        studentId: p.studentId,
        name: siswas.find((s) => s._id === p.studentId)?.name || "",
        DimensiLulusan: p.dimensiTercapai,
        Deskripsi: p.Deskripsi,
      }));

      await axios.put(
        `${process.env.REACT_APP_API_URL}api/kokulikuler/profile/${kokulikuler._id}`,
        { profileLulusan: payload },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      alert("Data Kokulikuler berhasil diperbarui");
    } catch (error) {
      console.error(error);
      alert("Gagal update data");
    }
  };

  /* ================= RENDER ================= */
  return (
    <div className="max-w-7xl mx-auto p-6 min-h-screen flex flex-col">
      <div className="flex gap-3 mb-4">
        <Link
          to={`/Kokurikuler/add/${id}`}
          className="flex items-center gap-2 px-4 py-2 rounded-lg 
               bg-blue-600 text-white text-sm font-medium
               hover:bg-blue-700 transition duration-200 shadow"
        >
          ➕ Add
        </Link>

        <Link
          to={`/Kokurikuler/Edit/${id}`}
          className="flex items-center gap-2 px-4 py-2 rounded-lg 
               bg-emerald-600 text-white text-sm font-medium
               hover:bg-emerald-700 transition duration-200 shadow"
        >
          ✏️ Edit
        </Link>
      </div>

      <h1 className="text-xl font-bold mb-4">Kokulikuler</h1>

      {/* FILTER */}
      <div className="grid grid-cols-4 gap-3 mb-4">
        <select
          name="kelas"
          value={filter.kelas}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        >
          <option value="">Kelas</option>
          {[1, 2, 3, 4, 5, 6].map((k) => (
            <option key={k} value={k}>
              {k}
            </option>
          ))}
        </select>

        <select
          name="rombel"
          value={filter.rombel}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        >
          <option value="">Rombel</option>
          {["A", "B", "C", "D"].map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </select>

        <input
          name="tahun"
          value={filter.tahun}
          onChange={handleFilterChange}
          placeholder="2024"
          className="border p-2 rounded"
        />

        <select
          name="semester"
          value={filter.semester}
          onChange={handleFilterChange}
          className="border p-2 rounded"
        >
          <option value="">Semester</option>
          <option value="1">1</option>
          <option value="2">2</option>
        </select>
      </div>

      <button
        onClick={handleCari}
        className="bg-indigo-600 text-white px-4 py-2 rounded mb-6"
      >
        Tampilkan
      </button>

      {/* TABEL */}
      {kokulikuler && siswas.length > 0 && (
        <table className="w-full border text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="border p-2">No</th>
              <th className="border p-2">Nama</th>
              <th className="border p-2">Dimensi Profil & Sub Dimensi</th>
              <th className="border p-2">Deskripsi</th>
            </tr>
          </thead>
          <tbody>
            {siswas.map((siswa, i) => {
              const profil = profileLulusan.find(
                (p) => p.studentId === siswa._id,
              ) || {
                dimensiTercapai: [],
                Deskripsi: "",
              };

              return (
                <tr key={siswa._id}>
                  <td className="border p-2 text-center">{i + 1}</td>
                  <td className="border p-2 font-semibold">{siswa.name}</td>

                  <td className="border p-2">
                    {kokulikuler.pilihanDimensi.map((d, idx) => {
                      const checked = profil.dimensiTercapai.some(
                        (x) =>
                          x.DimensiProfile === d.DimensiProfile &&
                          x.SubDimensi === d.SubDimensi,
                      );

                      return (
                        <label key={idx} className="flex gap-2 text-xs mb-1">
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() =>
                              toggleDimensi(siswa._id, {
                                DimensiProfile: d.DimensiProfile,
                                SubDimensi: d.SubDimensi,
                              })
                            }
                          />
                          <span>
                            <b>{d.DimensiProfile}</b> — {d.SubDimensi}
                          </span>
                        </label>
                      );
                    })}
                  </td>

                  <td className="border p-2">
                    <textarea
                      value={profil.Deskripsi}
                      onChange={(e) =>
                        setProfileLulusan((prev) =>
                          prev.map((p) =>
                            p.studentId === siswa._id
                              ? { ...p, Deskripsi: e.target.value }
                              : p,
                          ),
                        )
                      }
                      className="border rounded w-full h-24 text-xs p-1"
                      maxLength={100}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {kokulikuler && (
        <button
          onClick={handleUpdate}
          className="mt-4 bg-green-600 text-white px-6 py-2 rounded"
        >
          Update Data
        </button>
      )}

      <div>
        <Link to={`/profile/${id}`}>
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default TampilanKokulikuler;
